import React from 'react';
import { Panel, Button } from 'react-bootstrap';

const Article = (props) => {
  const { classes, article } = props;
  const url = `${article.url}`;
  return (
    <Panel className={classes.card} raised>
      <Panel.Body>
          <h3>
            {article.title.Value$$string}
          </h3>
          <p>
            {article.summary.Value$$string}
          </p>
        </Panel.Body>
        <Panel.Footer>
          <Button size="small" color="primary" href={url} target="_blank">
            Learn More
          </Button>
        </Panel.Footer>
    </Panel>
  )
}

export default Article;


// WEBPACK FOOTER //
// ./src/Components/roi-calculator/Article.jsx